module.exports = __webpack_public_path__ + "media/images/lp_consultation/mv-device-small-7586bf59a472769a587503fb00cf81f8.jpg";